export const listItemTextSx = ({ theme, itemTextSx }) => ({
  sx: {
    color: theme.palette.secondary.main,
    ...itemTextSx,
  },
});
